<!-- Prototype «Berufsbezeichnung Flow»: tabs + «(falls relevant)», hint,
     2-column grid (3 rows) with sub-choices under their Stufe, grey preview box. -->
<div
  class="flex flex-col"
  data-testid="level-capture"
  [class.ng-invalid]="showError()"
  [class.ng-touched]="showError()"
  (focusout)="onBlur()">
  <div class="flex flex-wrap items-center gap-2">
    <app-level-mode-toggle
      variant="tabs"
      [mode]="state().mode === 'ZYKLEN' ? 'zyklen' : 'stufen'"
      (modeChange)="setMode($event)" />
    @if (optional()) {
      <span class="text-bn-bright">{{
        'levelCapture.optional' | translate
      }}</span>
    }
  </div>
  @if (hint(); as h) {
    <p class="my-2 text-bn-bright">{{ h }}</p>
  } @else {
    <div class="h-3"></div>
  }

  @if (state().mode === 'STUFEN') {
    <div class="-ml-3 grid grid-cols-1 gap-x-4 sm:grid-cols-2">
      @for (row of ROWS; track row.key) {
        <div>
          <mat-checkbox
            class="bn-capture-row"
            [attr.data-testid]="row.testId"
            [checked]="state()[row.key]"
            (change)="setFlag(row.key, $event.checked)"
            >{{ row.label }}</mat-checkbox
          >
          <!-- Sub-choices directly under their Stufe, aligned with its label. -->
          @if (subChoices()[row.key]; as sub) {
            <div class="mb-2 ml-10 flex flex-wrap gap-2">
              @if (sub.key === 'primar') {
                @for (s of SUBS; track s.key) {
                  <button
                    type="button"
                    [attr.data-testid]="'capture-chip-' + s.key"
                    class="chip"
                    [class.chip-on]="has(state().primarSub, s.key)"
                    [attr.aria-pressed]="has(state().primarSub, s.key)"
                    (click)="toggleSub(s.key)">
                    {{ s.label }}
                  </button>
                }
              } @else {
                @for (spec of sub.specs; track spec) {
                  <button
                    type="button"
                    [attr.data-testid]="'capture-chip-' + spec"
                    class="chip"
                    [class.chip-on]="has(state()[sub.key], spec)"
                    [attr.aria-pressed]="has(state()[sub.key], spec)"
                    (click)="toggleSpec(sub.key, spec)">
                    {{ specLabel(spec) }}
                  </button>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="-ml-3 grid grid-cols-1 gap-x-4 sm:grid-cols-2">
      @for (z of ZYKLEN; track z.key) {
        <mat-checkbox
          class="bn-capture-row"
          [attr.data-testid]="'capture-zyklus-' + z.key"
          [checked]="has(state().zyklen, z.key)"
          (change)="toggleZyklus(z.key)"
          >{{ z.display }}</mat-checkbox
        >
      }
    </div>
  }

  <!-- «Stufenanzeige im Profil»: how the selection reads on the profile;
       hidden until something is ticked. -->
  @if (preview(); as p) {
    <p
      class="mt-3 flex flex-wrap items-baseline gap-2 rounded-lg bg-bn-box px-3 py-2"
      data-testid="capture-preview">
      <span class="text-bn-bright">{{
        'levelCapture.preview' | translate
      }}</span>
      <!-- [textContent], not {{ }}: browser translation swaps text nodes for
           its own, so an interpolated update would keep the stale text. -->
      <strong class="font-semibold" [textContent]="p"></strong>
    </p>
  }

  @if (showError()) {
    <p class="mt-2 text-sm text-light-error" data-testid="capture-error">
      {{ 'levelCapture.required' | translate }}
    </p>
  }
</div>
